(function () {
  if (window.__lpTintasReady) return;
  window.__lpTintasReady = true;
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function refreshCart() {
    if (typeof window.updateCart === 'function') {
      window.updateCart();
    } else {
      window.location.href = root() + '?cart_show';
    }
  }
  function message(btn, text) {
    var box = btn.parentNode.querySelector('.lp-tinta-msg');
    if (box) box.textContent = text || '';
  }
  function add(items, btn) {
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    message(btn, '');
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().then(function (e) {
            throw new Error((e && e.description) || 'Não foi possível adicionar. Tente novamente.');
          }, function () {
            throw new Error('Não foi possível adicionar. Tente novamente.');
          });
        }
        refreshCart();
      })
      .catch(function (err) {
        message(btn, err.message);
      })
      .then(function () {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
      });
  }
  document.addEventListener('click', function (e) {
    var copy = e.target.closest('[data-lp-copy]');
    if (copy) {
      var code = copy.getAttribute('data-lp-copy');
      var original = copy.textContent;
      var done = function () {
        copy.textContent = 'Copiado!';
        setTimeout(function () { copy.textContent = original; }, 2000);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else {
        done();
      }
      return;
    }
    var step = e.target.closest('[data-lp-step]');
    if (step) {
      var input = step.parentNode.querySelector('input');
      var v = (parseInt(input.value, 10) || 1) + Number(step.getAttribute('data-lp-step'));
      input.value = Math.max(1, v);
      return;
    }
    var single = e.target.closest('[data-lp-add]');
    if (single) {
      e.preventDefault();
      var card = single.closest('.lp-tinta-card');
      var qtyInput = card ? card.querySelector('input[name="qty"]') : null;
      var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      add([{ id: Number(single.getAttribute('data-variant')), quantity: qty }], single);
      return;
    }
    var kit = e.target.closest('[data-lp-kit]');
    if (kit) {
      e.preventDefault();
      var ids = (kit.getAttribute('data-variants') || '').split(',').filter(Boolean);
      if (!ids.length) return;
      add(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), kit);
    }
  });
})();
